'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { buildRumInitConfiguration } from '@/lib/datadog/rum-config';

// Session replay is off and token URLs are redacted: see lib/datadog/rum-config.ts.

export function DatadogInit() {
  useEffect(() => {
    if (datadogRum.getInitConfiguration()) return;

    const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
    const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
    if (!applicationId || !clientToken) return;

    const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV;
    const env =
      process.env.NEXT_PUBLIC_DATADOG_ENV ??
      (vercelEnv === 'production'
        ? 'prod'
        : vercelEnv === 'preview'
          ? 'preview'
          : 'dev');

    const version =
      process.env.NEXT_PUBLIC_DATADOG_VERSION ??
      process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA?.slice(0, 7) ??
      'local';

    datadogRum.init({
      ...buildRumInitConfiguration({
        applicationId,
        clientToken,
        site: process.env.NEXT_PUBLIC_DATADOG_SITE,
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
        env,
        version,
      }),
      plugins: [reactPlugin({ router: false })],
    });
  }, []);

  return null;
}
